import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useCallback } from 'react';
import { defaultProps } from './styles.js';
import { useDisclosure, ListItem, Box, Stack, Collapse, UnorderedList } from '@chakra-ui/react';
import { Icon } from '../Icon/component.js';
import Button from '../Button/component.js';
import { ButtonVariant } from '../Button/types.js';
import { Typography } from '../Typography/component.js';
var _excluded = ["submenu", "icon", "name", "onItemClick", "completeIcon", "activeIcon", "lockIcon", "complete", "to", "id", "active", "isExpanded", "iconSize", "iconColor"];
var _NavListItem = function NavListItem(props) {
  /**
   * Vars
   */
  var submenu = props.submenu,
    icon = props.icon,
    name = props.name,
    onItemClick = props.onItemClick,
    _props$completeIcon = props.completeIcon,
    completeIcon = _props$completeIcon === void 0 ? 'badge-check' : _props$completeIcon,
    _props$activeIcon = props.activeIcon,
    activeIcon = _props$activeIcon === void 0 ? 'circle-small' : _props$activeIcon,
    _props$lockIcon = props.lockIcon,
    lockIcon = _props$lockIcon === void 0 ? 'lock' : _props$lockIcon,
    complete = props.complete;
  props.to;
  var id = props.id,
    _props$active = props.active,
    active = _props$active === void 0 ? false : _props$active,
    _props$isExpanded = props.isExpanded,
    isExpanded = _props$isExpanded === void 0 ? false : _props$isExpanded,
    _props$iconSize = props.iconSize,
    iconSize = _props$iconSize === void 0 ? 'xs' : _props$iconSize,
    _props$iconColor = props.iconColor,
    iconColor = _props$iconColor === void 0 ? '#0D7978' : _props$iconColor,
    rest = _objectWithoutProperties(props, _excluded);

  /**
   * Hooks
   */
  var _useDisclosure = useDisclosure({
      defaultIsOpen: isExpanded
    }),
    isOpen = _useDisclosure.isOpen,
    onToggle = _useDisclosure.onToggle;

  /**
   * Methods
   */

  var handleClick = useCallback(function () {
    if (submenu) {
      onToggle();
      return;
    }
    if (!onItemClick) {
      return;
    }
    onItemClick(props);
  }, [submenu, onToggle, onItemClick, props]);

  /**
   * DOM
   */
  var navIcon = submenu && !icon ? 'square' : icon;
  var toggleIcon = isOpen ? 'chevron-up' : 'chevron-down';
  var isAriaExpanded = !!(submenu && isOpen);
  var hasSubMenu = !!(submenu && submenu.length > 0);
  var isActive = !submenu && active;
  var isLocked = !submenu && !active && !complete;
  var isCompleted = !submenu && !active && complete;
  var computedProps = _objectSpread2(_objectSpread2({}, defaultProps), rest);
  return /*#__PURE__*/React.createElement(ListItem, {
    "aria-expanded": isAriaExpanded,
    listStyleType: "none"
  }, /*#__PURE__*/React.createElement(Box, _extends({
    pointerEvents: isLocked ? 'none' : 'auto',
    opacity: isLocked ? 0.5 : 1,
    key: id,
    "aria-expanded": isAriaExpanded
  }, computedProps, {
    fontSize: hasSubMenu || isLocked ? computedProps.fontSize : 14,
    navIcon: computedProps.fontSize,
    bgColor: isActive ? computedProps.bgColor || 'surface-active' : 'transparent'
  }), /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    align: "center",
    justify: "space-between",
    flex: 1
  }, /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    align: "center"
  }, navIcon && /*#__PURE__*/React.createElement(Box, {
    width: navIcon && props.ps
  }, /*#__PURE__*/React.createElement(Icon, {
    iconName: navIcon
  })), /*#__PURE__*/React.createElement(Button, {
    variant: ButtonVariant.PLAIN,
    isActive: isActive,
    onClick: isLocked ? function () {} : handleClick
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "p"
  }, name))), active && !!activeIcon && /*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    color: iconColor,
    iconName: activeIcon
  }), isCompleted && /*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    color: iconColor,
    iconName: completeIcon
  }), isLocked && !!lockIcon && /*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    color: iconColor,
    iconName: lockIcon
  }), submenu && /*#__PURE__*/React.createElement(Icon, {
    iconName: toggleIcon
  }))), hasSubMenu && /*#__PURE__*/React.createElement(Collapse, {
    "in": isOpen
  }, /*#__PURE__*/React.createElement(UnorderedList, {
    spacing: 2,
    ml: 4,
    key: "submenu-list-".concat(id)
  }, submenu.map(function (item) {
    return /*#__PURE__*/React.createElement(_NavListItem, _extends({
      key: item.id,
      onItemClick: onItemClick
    }, item, {
      ps: "24px"
    }));
  }))));
};
_NavListItem.displayName = "NavListItem";
export { _NavListItem as NavListItem };